import React, { type CSSProperties, type HTMLAttributes } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface SortableCollegeRowProps {
    id: number;
    disabled: boolean;
    children: (options: {
        setNodeRef: (node: HTMLElement | null) => void;
        setActivatorNodeRef: (node: HTMLElement | null) => void;
        style: CSSProperties;
        isDragging: boolean;
        handleProps?: HTMLAttributes<HTMLElement>;
        rowListeners?: HTMLAttributes<HTMLElement>;
    }) => React.ReactNode;
}

export default function SortableCollegeRow({ id, disabled, children }: SortableCollegeRowProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id,
        disabled,
    });

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <>
            {children({
                setNodeRef,
                setActivatorNodeRef,
                style,
                isDragging,
                handleProps: disabled ? undefined : { ...attributes },
                rowListeners: disabled ? undefined : listeners,
            })}
        </>
    );
}
